// extracted by mini-css-extract-plugin
export default {"textContainer":"PopulationBasedFundingClickableText_textContainer__Lhj1Y"};